import React from 'react';
import './select-color.less';
import { selectColorList } from './select-color-list';

interface ISelectColorProps {
    index: number;
    onSelectIndex: (index: number, key: string) => void;
    colorList?: typeof selectColorList;
}

const SelectColor = ({ index, onSelectIndex, colorList }: ISelectColorProps) => {
    const selectList = colorList ?? selectColorList;
    return (
        <div className="m-select-color">
            <ul className="m-select-color__list">
                {selectList.map((v, i) => {
                    const style: React.CSSProperties = {
                        background: v.value,
                    };
                    const active = index === i;
                    return (
                        <li
                            key={i}
                            className={active ? 'active' : ''}
                            onClick={() => onSelectIndex(i, v.key)}
                            style={style}
                        ></li>
                    );
                })}
            </ul>
        </div>
    );
};
export default SelectColor;
